import React, { useMemo } from 'react';
import Header from './Layout/Header';
import TabNavigation from './Layout/TabNavigation';
import PropertyAnalyzer from './PropertyAnalyzer';
import Portfolio from './Portfolio';
import TaxOptimizer from './TaxOptimizer';
import Mietpreise from './Mietpreise';
import Statistik from './Statistik';
import Wasserfall from './Wasserfall';
import LOI from './LOI';
import Report from './Report';
import Sanierung from './Sanierung';
import ExperimentalFeatures from './ExperimentalFeatures';
import LegalCompliance from './LegalCompliance';
import Readme from './Readme';
import { useApp } from '../contexts/AppContext';

const MainDashboard: React.FC = () => {
  const { activeTab } = useApp();

  const renderContent = useMemo(() => {
    switch (activeTab) {
      case 'analyzer':
        return <PropertyAnalyzer />;
      case 'portfolio':
        return <Portfolio />;
      case 'taxOptimizer':
        return <TaxOptimizer />;
      case 'mietpreise':
        return <Mietpreise />;
      case 'statistik':
        return <Statistik />;
      case 'wasserfall':
        return <Wasserfall />;
      case 'loi':
        return <LOI />;
      case 'report':
        return <Report />;
      case 'sanierung':
        return <Sanierung />;
      case 'experimental':
        return <ExperimentalFeatures />;
      case 'compliance':
        return <LegalCompliance />;
      case 'readme':
        return <Readme />;
      default:
        return <PropertyAnalyzer />;
    }
  }, [activeTab]);

  return (
    <div className="max-w-7xl mx-auto">
      <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
        <Header />
        <TabNavigation />
        <div className="p-8">
          {renderContent}
        </div>
      </div>
    </div>
  );
};

export default MainDashboard;